import { createSelector } from 'reselect';
import { RootState } from '../store.types';
import { SwitchViewState } from './models';


const selectSwitchViewState = (state: RootState): SwitchViewState => (state.switchView);

export const selectSwitchViewSelected = createSelector(
  [selectSwitchViewState],
  (state: SwitchViewState) => state ? state.selectedView : null
);